import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GenericTableModel } from "../../../model/generic-table.model";

@Injectable()
export abstract class EditableTableService {

	public onChangeOptions$ = new Subject();
	public onCustomEvents$ = new Subject();
	public onRowClick$ = new Subject();

	/**
	 * Get Data
	 */
	abstract getData(integrationParams: GenericTableModel): Observable<any>

	/**
	 * Get Custom Data
	 */
	abstract getCustomData(integrationParams: GenericTableModel, paramater?: any): Observable<any>

	/**
	 * Get Data
	 */
	abstract saveData(integrationParams: GenericTableModel, payload: any[], paramater?: any): Observable<any>

	/**
	 * Save Data using post
	 */
	abstract savePostData(integrationParams: GenericTableModel, payload: any[]): Observable<any>

	/**
	 * Event to delete elements one by one
	 */
	abstract deleteModel(integrationParams: GenericTableModel, payload: any): Observable<any>
}
